<template>
  <div v-if="fileName && path">
    <iframe height="100%" width="100%" :src="getFilePath"></iframe>
  </div>
</template>
<script>
export default {
  name: 'PDFJSViewer',
  props: {
    fileName: {
      type: String,
      default: null,
    },
    path: {
      type: String,
      default: null,
    },
  },
  computed: {
    getFilePath() {
      if (this.fileName !== '') {
        return this.path + '?file=' + this.fileName;
      }
      return this.path;
    },
  },
};
</script>
<style scoped>
div {
  height: 79vh;
}
</style>
